import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import authAxios from "../../../config/authAxios"


const initialState = { status: null, loading: false, data: [], error: "", message: "" }



export const publisherMonthlyStatsAction = createAsyncThunk(
    'publisher-monthly-stats',
    async (data, { rejectWithValue }) => {
        try {
            const res = await authAxios.get(`/admins/api/publisher-monthly-stats?publisher_id=${data?.publisher_id}`)
            return res?.data
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)


export const publisherMonthlyStatsSlice = createSlice({
    name: 'publisher-monthly-stats',
    initialState,
    reducers: {},
    extraReducers:
        (builder) => {
            builder.addCase(publisherMonthlyStatsAction.pending, (state) => {
                state.loading = true
            })
            builder.addCase(publisherMonthlyStatsAction.fulfilled, (state, action) => {
                state.loading = false
                state.data = action?.payload?.data
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
            builder.addCase(publisherMonthlyStatsAction.rejected, (state, action) => {
                state.loading = false
                state.error = action?.payload?.error
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
        },

})



export const publisherMonthlyStatsReducer = publisherMonthlyStatsSlice.reducer

